import React from 'react';
import { Controller } from 'react-hook-form';
import styled from '@emotion/styled';
import { FormControl, FormHelperText } from '@mui/material';
import { image } from 'src/theme';
import { DatePicker } from '@mui/x-date-pickers';
import { RequiredMark } from '@/components/input/InputBasic';
import { mq } from '@/utils/mediaQuery';
import { RegularText } from '../text';

const StyledSelectInputContainer = styled.div(() => ({
  minHeight: '8rem',
  width: '100%',
}));

const StyledDatePicker = styled(DatePicker)(() => ({
  maxHeight: '5.6rem',

  [mq('desktop')]: {
    fontSize: '1.6rem',
  },
}));

const InputDate = ({ control, name, label, required, errors }) => {
  return (
    <StyledSelectInputContainer>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <FormControl error={!!errors[name]}>
              <StyledDatePicker
                {...field}
                value={field.value !== '' ? field.value : null}
                label={
                  <>
                    <RegularText id={label} fontSize="1.6rem" />
                    {required && <RequiredMark>*</RequiredMark>}
                  </>
                }
                format="YYYY-MM-DD"
                disablePast
                onChange={(val) => {
                  if (val !== null) {
                    field.onChange(val);
                  }
                }}
                slots={{
                  openPickerIcon: () => (
                    <img src={image.datepickerIcon.default} alt="picker icon" width={24} />
                  ),
                }}
                slotProps={{
                  textField: {
                    error: !!errors[name],
                  },
                  openPickerButton: {
                    sx: {
                      padding: '1rem',
                      right: 1,
                    },
                  },
                }}
              />

              {errors[name] && (
                <FormHelperText style={{ margin: 0, fontSize: '1.1rem' }}>
                  {errors[name].message}
                </FormHelperText>
              )}
            </FormControl>
          );
        }}
      />
    </StyledSelectInputContainer>
  );
};

export default InputDate;
